import {csvParse, dsvFormat, tsvParse} from "d3-dsv";
import text from "./text.js";

function dsvParse(parse) {
  return function(input, init, row) {
    if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
    return text(input, init).then(function(response) {
      return parse(response, row);
    });
  };
}

export default function dsv(delimiter, input, init, row) {
  if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
  var format = dsvFormat(delimiter);
  return text(input, init).then(function(response) {
    return format.parse(response, row);
  });
}

export var csv = dsvParse(csvParse);
export var tsv = dsvParse(tsvParse);



//////////////////
// WEBPACK FOOTER
// ./~/d3-fetch/src/dsv.js
// module id = ./node_modules/d3-fetch/src/dsv.js
// module chunks = 53